import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Building, Users, Shield } from 'lucide-react';
import { useSiteContent } from '@/hooks/useSiteContent';
import { AnimatedSection } from '@/hooks/useScrollAnimation';

const CompanyIntro = () => {
  const { getContentText, loading } = useSiteContent();

  const features = [
    {
      icon: Users,
      title: getContentText('usp-1-title', 'Persoonlijke Service'),
      description: getContentText('usp-1-description', 'Directe communicatie met de verhuurder, snelle reactietijden en een persoonlijke aanpak voor elke huurder.')
    },
    {
      icon: Shield,
      title: getContentText('usp-2-title', 'Betrouwbaar'),
      description: getContentText('usp-2-description', 'Met jarenlange ervaring in vastgoedbeheer zorgen wij voor professioneel onderhoud en transparante communicatie.')
    },
    {
      icon: Building,
      title: getContentText('usp-3-title', 'Eigen Portefeuille'),
      description: getContentText('usp-3-description', 'Wij verhuren uitsluitend onze eigen panden, waardoor wij volledige controle hebben over kwaliteit en service.')
    }
  ];

  if (loading) {
    return (
      <section className="py-24 section-warm">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <div className="animate-pulse">
              <div className="h-12 bg-muted rounded mx-auto mb-6 max-w-md"></div>
              <div className="h-6 bg-muted/50 rounded mx-auto max-w-2xl"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 md:py-20 lg:py-24 xl:py-28 section-warm relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 pattern-subtle opacity-50"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <AnimatedSection className="text-center mb-12 lg:mb-16">
          <div className="divider-elegant mx-auto mb-4 lg:mb-6"></div>
          <h2 className="font-serif text-primary mb-4 lg:mb-6">
            {getContentText('intro-title', 'Croostenburght Beheer')}
          </h2>
          <p className="text-muted-foreground max-w-3xl mx-auto leading-relaxed text-base md:text-lg">
            {getContentText('intro-description', 'Wij zijn gespecialiseerd in het beheer en de verhuur van ons eigen vastgoedportfolio. Met jarenlange ervaring bieden wij kwalitatieve woon- en bedrijfsruimtes met persoonlijke service.')}
          </p>
        </AnimatedSection>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <AnimatedSection key={index} delay={index * 150}>
              <Card className="group h-full bg-card/80 backdrop-blur-sm border-border/50 shadow-card hover:shadow-card-hover transition-all duration-500 hover:-translate-y-2">
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-500">
                    <feature.icon className="h-8 w-8 text-primary" />
                  </div>
                  <h3 className="font-serif text-xl font-medium text-primary mb-3">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyIntro;